import script from "./AddSchoolForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSchoolForm.vue?vue&type=script&setup=true&lang=js"

import "./AddSchoolForm.vue?vue&type=style&index=0&id=d53f46c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d53f46c6"]])

export default __exports__